import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { Patient } from "lib/build/patients";

import { useFormatName } from "src/common/hooks/useFormatName";
import { useLastEventValueByQuery } from "src/features/events";
import { useOrgModParams } from "src/features/orgmod";
import { fetchPatient } from "src/features/patient/actions";
import { queries } from "src/features/patient/queries";
import { PatientState } from "src/features/patient/types";
import { AppDispatch } from "src/store";

export function usePatientIdParam(): string {
	const { patientId } = useParams<"patientId">();
	return patientId || "";
}

interface UseSelectPatientResult {
	isLoading: boolean;
	patient: Patient | null;
}

export function useSelectPatient(id: string): UseSelectPatientResult {
	const { [id]: { isLoading = true, patient = null } = {} } = useSelector(
		({ patient }: { patient: PatientState }) => patient
	);
	return { isLoading, patient };
}

export function useFetchPatient(patientId: string): void {
	const dispatch: AppDispatch = useDispatch();
	const { org, mod } = useOrgModParams();
	React.useEffect(() => {
		dispatch(fetchPatient({ org, mod, patientId }));
	}, [dispatch, org, mod, patientId]);
}

export function usePatientName(): string | undefined {
	const formatName = useFormatName();
	const title = useLastEventValueByQuery<string>(queries.title);
	const firstName = useLastEventValueByQuery<string>(queries.firstName);
	const lastName = useLastEventValueByQuery<string>(queries.lastName);
	if (firstName === undefined || lastName === undefined) {
		return;
	}
	return formatName({ title, firstName, lastName });
}

export function usePatientDateOfBirth(): string | undefined {
	return useLastEventValueByQuery<string>(queries.dateOfBirth);
}
